<template>
<div>
	<v-card flat max-width="950px" class="mx-auto transparent mb-12 pb-12">

        <div class="headline font-weight-bold primary--text ml-6 mt-6">TO LEARN</div>

        <v-row class="mt-6 mt-sm-12">
            <v-col cols="12" sm="6">
                <div class="d-flex justify-center justify-sm-end mr-sm-6">
                    <v-card flat width="300px" hover color="#FF3971" @click="$router.push('/videos')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('skills-path')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/3steps-skills-path.png')" width="40"></v-img>
                            </div>
                            <div class="subtitle-1 font-weight-bold primary--text py-6">
                                3 STEPS SKILLS PATH
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>

            <v-col cols="12" sm="6">
                 <div class="d-flex justify-center justify-sm-start ml-sm-6">
                    <v-card flat width="300px" hover color="#B7FBFD" @click="$router.push('/video-library')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('video-library')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/video-library.png')" width="40"></v-img>
                            </div>
                            <div class="subtitle-1 font-weight-bold primary--text py-6">
                                VIDEO LIBRARY
                            </div>
                        </div>
                    </v-card>
                 </div>
            </v-col>
        </v-row>

        <v-row class="mt-sm-4">
            <v-col cols="12">
                <div class="d-flex justify-center">
                    <v-card flat width="300px" hover color="#808CE2" @click="$router.push('/articles')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right @click.stop="show('interesting-stuff')">
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/interesting-stuff.png')" width="40"></v-img>
                            </div>
                            <div class="subtitle-1 font-weight-bold primary--text py-6">
                                INTERESTING STUFF
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
        </v-row>

	</v-card>

    <DiagInfo
        :model="showDiag" 
        @accept="showDiag=false"
        :text="textDiag"/>
</div>
</template>

<script>
export default {
    data: () => ({
        showDiag: false,
        textDiag: ''
    }),
    methods: {
        show(str) {
            if (str == 'skills-path') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>3 Steps Skills Path</div> <div class='mt-2'>These courses are specially designed to help you develop your 5Cs skills (creativity, critical thinking, communication, collaboration, and courage). Once you have completed all the videos, you'll be more prepared than most for business meetings, dates, college interviews, job applications, and everyday work.</div>"
            }

            if (str == 'video-library') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Video Library</div> <div class='mt-2'>Coming soon.</div>"
            }

            if (str == 'interesting-stuff') {
                this.textDiag = "<div class='headline font-weight-medium primary--text'>Interesting Stuff</div> <div class='mt-2'>This is where your captains will link articles and videos that could be helpful to you.</div>"
            }

            this.showDiag = true;
        }
    }
}
</script>
